export default __webpack_public_path__ + "static/media/amaze-8.2afbb5bc.jpg";